module.exports = __webpack_public_path__ + "static/media/passbook.c9196683.svg";